import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'edit-term-modal',
	templateUrl: './edit-term-modal.component.html',
	styles: []
})
export class EditTermModalComponent implements OnInit {
	@ViewChild('docEditTermForm') docEditTermForm: FormGroupDirective;
	@Input() term;
	editTermForm: FormGroup;

	constructor(
		public activeModal: NgbActiveModal,
		private fb: FormBuilder) {
	}

	ngOnInit(): void {
		this.editTermForm = this.fb.group({
			description: [this.term.description, Validators.required]
		})
	}

	submit() {
		this.activeModal.close(this.editTermForm.value);
	}

}

